import React from 'react'
import '../about me/AboutMe.css'


export default function About_me() {
    return (
        <>
        <section className="content my-5">
            <h1 className='d-flex justify-content-center my-3 skill'>About Me</h1>
        
        <div id="about" className="container paddsection">
    <div className="container mid">
      <div className="row justify-content-between">

        <div className="col-lg-4 ">
          <div className="div-img-bg resimg">
            <div className="about-img">
              <img src="https://gdurl.com/EfPs" className="img-responsive self-img" alt="me"/>
            </div>
          </div> 
        </div> 

        <div className="col-lg-7 left">
          <div className="about-descr">

            <h3>My Education</h3>
            <p style={{marginBottom:"0px", fontSize:"0.8rem"}}>Bachelors of Technology</p>
            <p style={{marginBottom:"0px"}}><strong>Raj Kumar Goel Institute of Technology</strong></p>
            <p style={{marginBottom:"0px", fontSize:"1rem"}}>Electrical & Electronics Engineering (2018-2022)</p>
            <br />
            <br />
            <p style={{marginBottom:"0px", fontSize:"0.8rem"}}>Intermediate/12th</p>
            <p style={{marginBottom:"0px"}}><strong>Udai Pratap Public School</strong></p>
            <p style={{marginBottom:"0px", fontSize:"1rem"}}>Science PCM (2018)</p>
            <br />
            <br />
            <p style={{marginBottom:"0px", fontSize:"0.8rem"}}>High School/10th</p>
            <p style={{marginBottom:"0px"}}><strong>Udai Pratap Public School</strong></p>
            <p style={{marginBottom:"0px", fontSize:"1rem"}}>(2016)</p>


          </div>
          <div className='button-left my-4'>
          <a href="https://drive.google.com/file/d/1NoZaLaiUjubIcyfFkhjIpDMnb5Q5MlmZ/view?usp=sharing" target="_blank" rel='noreferrer'><button className="btn btn-5 gap" style={{marginTop:"0%"}}>Download Resume</button></a>
            
              <a className='redir' href="https://www.linkedin.com/in/avanish-chandra-pandey-43468a19a/" alt="LinkedIn profile" target="_blank" rel='noreferrer'>
							<div className="button-group-li">
                <button className="btn btn-5 text-timeline">View on LinkedIn</button> 
								{/* <div className="text-timeline">View on LinkedIn</div> */}
								<div className="icon-li"><ion-icon name="logo-linkedin" style={{color:"white"}}></ion-icon></div>
							</div>
						</a>
            </div>
        </div>
      </div>
    </div>
  </div>
  </section>
    </> 
    )
}
